import { Controller } from "@hotwired/stimulus"

// Expandable lines for the P&L statement table, and the "% of sales" switch. A group is a <tbody>:
// its first row is the line, the rows after it are what the line is made of, shown only while the
// group has .is-open (see .st-group in the stylesheet). One button expands everything, and turns
// into "Collapse all" once everything is open (also when the last line is opened by hand).
export default class extends Controller {
  static targets = ["group", "table", "toggleAllLabel"]
  static values = { shareClass: { type: String, default: "show-share" } }

  connect() {
    this.updateToggleAll()
  }

  toggle(event) {
    const group = event.currentTarget.closest("tbody")
    this.setOpen(group, !group.classList.contains("is-open"))
    this.updateToggleAll()
  }

  toggleAll() {
    const open = !this.allOpen()
    this.expandable().forEach((group) => this.setOpen(group, open))
    this.updateToggleAll()
  }

  toggleShare(event) {
    this.tableTarget.classList.toggle(this.shareClassValue, event.currentTarget.checked)
  }

  setOpen(group, open) {
    const button = group.querySelector(".st-toggle")
    if (!button) return

    group.classList.toggle("is-open", open)
    button.setAttribute("aria-expanded", open ? "true" : "false")
  }

  expandable() {
    return this.groupTargets.filter((group) => group.querySelector(".st-toggle"))
  }

  allOpen() {
    const groups = this.expandable()
    return groups.length > 0 && groups.every((group) => group.classList.contains("is-open"))
  }

  updateToggleAll() {
    if (!this.hasToggleAllLabelTarget) return

    this.toggleAllLabelTarget.textContent = this.allOpen() ? "Collapse all" : "Expand all"
  }
}
